import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EMenuButtonItemType, IMenuButtonProperties } from '../../../store/models/menu-button.model';
import { IContentItem } from '../../../store/models/content.model';

@Component({
  selector: 'app-content-info-mobile-row',
  templateUrl: './content-info-mobile-row.component.html',
  styleUrls: ['./content-info-mobile-row.component.scss'],
})
export class ContentInfoMobileRowComponent implements OnInit {

  @Input() item: IContentItem;
  @Input() contentGroupName: string;

  @Output() test: EventEmitter<IContentItem> = new EventEmitter();

  menuItems: IMenuButtonProperties = {
    items: [
      {
        label: 'Preview',
        type: EMenuButtonItemType.LINK,
        getRoute: (target: IContentItem) => (['/contents', target.content_id, 'preview', {
          group_name: this.contentGroupName,
        }]),
      },
      {
        label: 'Test',
        type: EMenuButtonItemType.BUTTON,
        onClick: (target: IContentItem) => this.test.emit(target),
      },
    ],
  };

  constructor() {
  }

  ngOnInit(): void {
  }

}
